import { Head } from "@inertiajs/react"

import AuthLayout from "@/layouts/auth-layout"
import { onboardingNewPath } from "@/routes"

interface Props {
  email: string
}

export default function CheckYourEmail({ email }: Props) {
  return (
    <AuthLayout
      title="Check your email"
      description="We just sent you a link. Click it to step into your demo (or to book your call, if you picked Dimensioner)."
    >
      <Head title="Check your email" />
      <div className="grid gap-3 text-sm">
        <p>
          We sent a magic link to <strong>{email}</strong>.
        </p>
        <p className="text-muted-foreground">
          Link is good for 30 minutes. If you don't see it, check spam, or{" "}
          <a href={onboardingNewPath()} className="underline">
            re-submit
          </a>{" "}
          to send a fresh one.
        </p>
      </div>
    </AuthLayout>
  )
}
